import { Component, Inject, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Recipes } from 'app/models/receta.models';
import { RecetaService } from 'app/services/receta.service';
import { AddEditInsumoComponent } from '../add-edit-insumo/add-edit-insumo.component';
import Swal from 'sweetalert2';
import { ProductoService } from 'app/services/producto.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-receta-edit-create',
  templateUrl: './receta-edit-create.component.html',
  styleUrls: ['./receta-edit-create.component.css'],
})
export class RecetaEditCreateComponent implements OnInit, OnDestroy {
  recetaForm: FormGroup;
  receta: Recipes;
  insumos: any[] = [];
  tipo: string = 'Nueva';
  insumosReceta: MatTableDataSource<any>;
  displayedColumns = ['articulo', 'cantidad', 'unidad', 'acciones'];
  variantes: any[] = [];
  unidades: any[] = [];
  onlyReadRecipe: boolean = false;
  private dialogSubscriptions: Subscription[] = [];
  private formSubscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private recetaService: RecetaService,
    private productoService: ProductoService,
    public dialogRef: MatDialogRef<RecetaEditCreateComponent>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.insumosReceta = new MatTableDataSource();
    this.insumosReceta.data = [];
    this.receta = data.receta;
    this.unidades = data.unidades;
    this.onlyReadRecipe = data.onlyReadRecipe ?? false;
    this.recetaForm = this.fb.group({
      name: [''],
      description: [''],
      yieldMeasurementUnitId: [''],
      yieldQuantity: [1, Validators.required], // Cantidad final esperada
      finalVariantId: ['', Validators.required], // El producto final de la receta
    });
    this.recetaForm.get('yieldMeasurementUnitId').disable();
  }

  ngOnInit() {
    // Limpiar estado previo
    this.tipo = 'Nueva';
    this.receta = null;
    this.insumos = [];
    this.insumosReceta = new MatTableDataSource();
    this.displayedColumns = ['articulo', 'cantidad', 'unidad', 'acciones'];
    this.variantes = [];
    this.unidades = this.data.unidades || [];
    this.onlyReadRecipe = this.data.onlyReadRecipe ?? false;
    this.recetaForm.reset();
    this.recetaForm.get('yieldMeasurementUnitId').disable();

    this.getVariantes();
    if (this.data.receta) {
      this.receta = this.data.receta;
      this.recetaForm.patchValue(this.receta);
      this.tipo = 'Editar';
      this.recetaForm.get('finalVariantId').setValue(this.receta?.finalVariant?.id);
      this.recetaForm.get('yieldMeasurementUnitId').setValue(this.receta?.finalVariant?.article?.measurementUnitId);
      this.getInsumosByVariantId(this.receta.id);
      // Deshabilitar los campos solo después de asignar los valores
      if (this.onlyReadRecipe) {
        this.tipo = 'Visualizar';
        setTimeout(() => {
          Object.keys(this.recetaForm.controls).forEach(key => {
            this.recetaForm.controls[key].disable();
          });
        });
      }
    }
  }

 /*  ngAfterViewInit(): void {
    // Asegurar que el formulario tenga valores iniciales adecuados después de renderizar el componente
    setTimeout(() => {
      // Si estamos creando una nueva receta, inicializar solo con valores por defecto
      if (!this.receta) {
        this.recetaForm.patchValue({
          yieldQuantity: 1,
          name: '',
          description: ''
        });
      }
    }, 100);
  } */

  ngOnDestroy(): void {
    if (this.recetaForm) {
      this.recetaForm.reset();
    }
    this.receta = null;
    this.insumos = [];
    this.tipo = 'Nueva';
    this.insumosReceta = new MatTableDataSource();
    this.displayedColumns = ['articulo', 'cantidad', 'unidad', 'acciones'];
    this.variantes = [];
    this.unidades = [];
    this.onlyReadRecipe = false;

    // Desuscribir todas las suscripciones a afterClosed
    this.dialogSubscriptions.forEach(sub => sub.unsubscribe());
    this.dialogSubscriptions = [];

    // Desuscribir todas las suscripciones a valueChanges del formulario
    this.formSubscriptions.forEach(sub => sub.unsubscribe());
    this.formSubscriptions = [];
  }

  getInsumosByVariantId(id) {
    this.recetaService.getInsumosByVariantId(id).subscribe(
      (data: any) => {
        this.insumos = data;
        this.insumosReceta.data = this.insumos;
        this.insumosReceta._updateChangeSubscription();
      },
      error => {
        console.error(error);
      }
    );
  }

  getVariantes() {
    this.productoService.getVariantesDisponibleVenta().subscribe((data: any) => {
      this.variantes = data;
    });
  }

  updateInsumosTable(): void {
    this.insumosReceta.data = [...this.insumos];
    this.insumosReceta._updateChangeSubscription();
  }

  eliminarInsumo(insumo, event) {
    if (this.receta && !insumo.hasOwnProperty('articulo')) {
      event.preventDefault();
      event.stopPropagation();
      Swal.fire({
        title: `¿Desea eliminar el insumo?`,
        text: `${insumo.variant.name}`.toLocaleUpperCase(),
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
        cancelButtonText: 'No',
      }).then(result => {
        if (result.isConfirmed) {
          this.recetaService.deleteInsumo(insumo.id).subscribe(
            data => {
              const index = this.insumos.findIndex(e => e.variantId === insumo.variantId);
              this.insumos.splice(index, 1);
              this.updateInsumosTable();
              this.openSnackBar(
                `${insumo.variant.name} eliminado correctamente`,
                'Información'
              );
            },
            err => {
              console.log(err);
              this.openSnackBar(
                `Error al eliminar el ${insumo.variant.name}`,
                'Información'
              );
            }
          );
        }
      });
    } else {
      const index = this.insumos.findIndex(e => e.variantId === insumo.variantId);

      if (index !== -1) {
        this.insumos.splice(index, 1);
        this.insumosReceta.data = [...this.insumos];
        this.insumosReceta._updateChangeSubscription();
      }
    }
  }

  editarInsumo(insumo) {
    const dialogRef = this.dialog.open(AddEditInsumoComponent, {
      width: '500px',
      disableClose: true,
      data: {
        receta: this.receta,
        insumos: this.insumosReceta.data,
        tipo: 'Editar',
        insumo: { ...insumo },
      },
    });
    const sub = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        insumo.quantity = result.quantity;
        insumo.measurementUnitId = result.measurementUnitId;

        if (!insumo.hasOwnProperty('unidad')) {
          insumo.measurementUnit = result.unidad;
        }
        if (insumo.hasOwnProperty('unidad')) {
          insumo.unidad = result.unidad;
        }
        this.updateInsumosTable();
      }
    });
    this.dialogSubscriptions.push(sub);
  }

  agregarInsumo() {
    // abrimos el dialogo para agregar un insumo
    const dialogRef = this.dialog.open(AddEditInsumoComponent, {
      width: '500px',
      disableClose: true,
      data: {
        receta: this.receta,
        insumos: this.insumosReceta.data,
        tipo: this.tipo,
      },
    });
    const sub = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.insumos.push(result);
        this.insumosReceta.data = this.insumos;
        this.insumosReceta._updateChangeSubscription();
      }
    });
    this.dialogSubscriptions.push(sub);
  }

  setNameReceta(varianteName) {
    // Establecer el nombre de la receta basado en el nombre de la variante
    this.recetaForm.patchValue({
      name: varianteName,
    });
    
    // Buscar la variante seleccionada para obtener su unidad de medida
    const selectedVariantId = this.recetaForm.get('finalVariantId').value;
    if (selectedVariantId) {
      const selectedVariant = this.variantes.find(v => v.id === selectedVariantId);
      if (selectedVariant && selectedVariant.article && selectedVariant.article.measurementUnitId) {
        // Establecer la unidad de medida correspondiente al artículo de la variante
        this.recetaForm.get('yieldMeasurementUnitId').setValue(selectedVariant.article.measurementUnitId);
      }
    }
  }

  guardarReceta() {
    if (this.recetaForm.valid) {
      // Usar siempre getRawValue para incluir campos deshabilitados
      const receta = this.recetaForm.getRawValue();
      // Eliminar yieldMeasurementUnitId si no es necesario enviarlo
      // delete receta.yieldMeasurementUnitId;
      receta.inputs = this.insumos;
      receta.recipeVariant = this.recetaForm.value.insumos;
      receta.yieldQuantity = Number(this.recetaForm.value.yieldQuantity);
      if (this.receta) {
        this.recetaService.updateReceta(this.receta.id, receta).subscribe({
          next: () => {
            Swal.fire({
              title: '¡Éxito!',
              text: 'Receta actualizada correctamente',
              icon: 'success',
              confirmButtonText: 'Aceptar',
            });
            this.dialogRef.close(true);
          },
          error: error => {
            console.error(error.message);
            Swal.fire({
              title: 'Error',
              text: 'No se pudo actualizar la receta',
              icon: 'error',
              confirmButtonText: 'Aceptar',
            });
          },
        });
      } else {
        this.recetaService.saveReceta(receta).subscribe({
          next: () => {
            Swal.fire({
              title: '¡Éxito!',
              text: 'Receta creada con éxito',
              icon: 'success',
              confirmButtonText: 'Aceptar',
            });
            this.dialogRef.close(true);
          },
          error: error => {
            console.error(error.message);
            Swal.fire({
              title: 'Error',
              text: 'Error al crear la receta',
              icon: 'error',
              confirmButtonText: 'Aceptar',
            });
          },
        });
      }
    }
  }

  onSubmit() {
    if (this.recetaForm.valid) {
      this.guardarReceta();
    } else {
      this.recetaForm.markAllAsTouched();
      Swal.fire({
        title: 'Formulario inválido',
        text: 'Por favor complete todos los campos requeridos',
        icon: 'warning',
        confirmButtonText: 'Aceptar',
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
}
